module.exports = __webpack_public_path__ + "img/influye-logo-old.1dae091b.png";